// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"136":"04fbcc28","198":"04fbcc28","324":"04fbcc28","389":"04fbcc28"}[chunkId] + ".chunk.css";
};